import React, { useEffect, useState } from 'react';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../firebaseConfig';
import { CSVLink } from 'react-csv';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import './AiSuggestions.css';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const CustomerReviews = () => {
  const [suggestions, setSuggestions] = useState([]);
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    const fetchSuggestions = async () => {
      const coffeeShopId = localStorage.getItem('coffee_shop_id');

      if (!coffeeShopId) {
        console.error('coffee_shop_id missing from localStorage');
        setSuggestions([]);
        return;
      }

      const q = query(
        collection(db, "reviews"),
        where('coffee_shop_id', '==', coffeeShopId)
      );
      const snapshot = await getDocs(q);
      setSuggestions(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    };

    fetchSuggestions();
  }, []);

  const sentimentData = [
    { name: t('positive'), value: suggestions.filter(s => s.feeling === 'positive').length },
    { name: t('neutral'), value: suggestions.filter(s => s.feeling === 'neutral').length },
    { name: t('negative'), value: suggestions.filter(s => s.feeling === 'negative').length },
  ];

  const hasSentimentData = sentimentData.some(item => item.value > 0);
  const COLORS = ['#4CAF50', '#FFC107', '#F44336'];

  return (
    <div className="suggestions-container1">
      <h2>🤖 {t('customer_reviews')}</h2>

      {hasSentimentData ? (
        <ResponsiveContainer width="100%" height={250}>
          <PieChart>
            <Pie data={sentimentData} dataKey="value" nameKey="name" cx="50%" cy="50%" outerRadius={80}>
              {sentimentData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS[index]} />
              ))}
            </Pie>
            <Tooltip />
            <Legend />
          </PieChart>
        </ResponsiveContainer>
      ) : (
        <p>{t('no_sentiment_data')}</p>
      )}

      <CSVLink data={suggestions} filename={"suggestions.csv"} className="export-btn">
        📥 {t('export_reviews')}
      </CSVLink>

      <button className="export-btn1" onClick={() => navigate(-1)}>
        ⬅️ {t('back')}
      </button>

      {suggestions.map((s) => (
        <div key={s.id} className="suggestion-card">
          <p>{s.comment}</p>
          <span className={`sentiment-tag ${s.feeling}`}>{t(s.feeling)}</span>
          {s.timestamp && (
            <small>{new Date(s.timestamp.seconds * 1000).toLocaleString()}</small>
          )}
        </div>
      ))}
    </div>
  );
};

export default CustomerReviews;